import { getAllDocuments } from "../external/firebase";
import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import '../css/Information.css';
import Information from "../components/Information";

const APIAnalytics = () => {
    const params = useParams();
    const [todayUsage, setTodayUsage] = useState(0);
    const [monthUsage, setMonthUsage] = useState(0);

    useEffect(() => {
        const fetchAnalytics = async () => {
            try {
                const dayWiseAnalytics = await getAllDocuments(`analytics/${params.apiKey}/indiaMarket`);
                const today = new Date();
                const todayStr = today.toISOString().split('T')[0];
                const currentMonth = today.getMonth();
                const currentYear = today.getFullYear();

                let totalMonth = 0;
                let todayValue = 0;

                dayWiseAnalytics.forEach(entry => {
                    const entryDate = new Date(entry.id);
                    if (entryDate.getMonth() === currentMonth && entryDate.getFullYear() === currentYear) {
                        totalMonth += entry.usageValue;
                    }
                    if (entry.id === todayStr) {
                        todayValue = entry.usageValue;
                    }
                });

                setTodayUsage(todayValue);
                setMonthUsage(totalMonth);
            } catch (error) {
                console.error('Error fetching analytics data:', error);
            }
        };

        fetchAnalytics();
    }, [params.apiKey]);

    return (
        <Information title={"API Usage Analytics"}>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
                <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', justifyContent: 'center' }}>
                    <div style={{
                        border: '2px solid #ccc',
                        borderRadius: '12px',
                        padding: '2rem',
                        minWidth: '200px',
                        textAlign: 'center',
                        backgroundColor: '#f9f9f9'
                    }}>
                        <h2 style={{ fontSize: '1.25rem', marginBottom: '1rem', color:"#0070f3" }}>This Month</h2>
                        <div style={{ fontSize: '2.5rem', color: '#0070f3', fontWeight: 'bold' }}>{monthUsage}</div>
                    </div>

                    <div style={{
                        border: '2px solid #ccc',
                        borderRadius: '12px',
                        padding: '2rem',
                        minWidth: '200px',
                        textAlign: 'center',
                        backgroundColor: '#f9f9f9'
                    }}>
                        <h2 style={{ fontSize: '1.25rem', marginBottom: '1rem', color: "#10b981" }}>Today</h2>
                        <div style={{ fontSize: '2.5rem', color: '#10b981', fontWeight: 'bold' }}>{todayUsage}</div>
                    </div>
                </div>
            </div>
        </Information>
    );
};

export default APIAnalytics;
